import {inject, Injectable} from '@angular/core';
import {ButtonRecordValue, RecordData} from "../../../../../types/records-table.types";
import {RecordsTableService} from "../../../../../services/records-table.service";
import {ErrorService} from "../../../../../services/error.service";
import {IsValidProductCardModalParams} from "../types/modal-record-table-item.types";

@Injectable({
  providedIn: 'root'
})
export class ModalRecordTableItemValidService {
  private recordsTableService: RecordsTableService = inject(RecordsTableService);
  private errorService: ErrorService = inject(ErrorService);

  public isValidBankDetails(recordData: RecordData): boolean {
    const isDocumentsPath = this.recordsTableService.getCurrentResourceType().path === 'documents';
    if (isDocumentsPath && !recordData['bankDetails']) { return false; }

    const isValid = !(!isDocumentsPath && !(recordData['bankDetails'] as RecordData)['bloggerId']);
    !isValid && this.errorService.showErrorMessage('Нельзя добавить реквизиты: Сначала нужно добавить блогера.');

    return isValid;
  }

  public isValidBloggerContact(recordData: RecordData): boolean {
    const isValid = !!(recordData['bloggerContact'] as RecordData)['bloggerId'];
    !isValid && this.errorService.showErrorMessage('Нельзя добавить контакт: Сначала нужно добавить блогера.');
    return isValid;
  }

  public isValidDefectsModal(recordData: RecordData): boolean {
    const isValid = !!(recordData['productCard'] as ButtonRecordValue)?.valid;
    !isValid && this.errorService.showErrorMessage('Ошибка: Продукт не привязан! Перейдите в артикулы для привязки!')
    return isValid;
  }

  public isValidDocumentModal(recordData: RecordData): boolean {
    const isValid = !!(recordData['documents'] as RecordData)?.id;
    !isValid && this.errorService.showErrorMessage('Документа с таким id нет!');
    return isValid;
  }

  public isValidProductCardModal(isValidProductCardModalParams: IsValidProductCardModalParams): boolean {
    const { path, recordData } = isValidProductCardModalParams;
    const isValid = path === 'feedbacks' && !(recordData['productCard'] as ButtonRecordValue).id;
    isValid && this.errorService.showErrorMessage('Ошибка: Продукт не привязан! Перейдите в артикулы для привязки!');
    return isValid;
  }

  public isValidNoteModal(recordData: RecordData, key: string): boolean {
    const isValid: Record<string, (recordData: RecordData) => boolean> = {
      noteChangePrice: () => this.isValidNoteChangePriceModal(recordData),
      advertisementKey: () => this.isValidNoteAdvertisementKeyModal(recordData)
    };

    return isValid[key]?.(recordData) || false;
  }

  public isValidWildberriesProductCardsModal(recordData: RecordData, key: string): boolean {
    const isValid: Record<string, (recordData: RecordData) => boolean> = {
      productCardGroupModalDto: () => this.isValidProductCardGroupModal(recordData)
    };

    return isValid[key]?.(recordData) || false;
  }

  private isValidNoteChangePriceModal(recordData: RecordData): boolean {
    const isValid = recordData['noteType'] === 'PRICE';
    !isValid && this.errorService.showErrorMessage('Тип заметки должен быть "Цена"!');
    return isValid;
  }

  private isValidNoteAdvertisementKeyModal(recordData: RecordData): boolean {
    const isValid = recordData['noteType'] === 'ADVERTISEMENT_KEY';
    !isValid && this.errorService.showErrorMessage('Тип заметки должен быть "Ключи"!');
    return isValid;
  }

  private isValidProductCardGroupModal(recordData: RecordData): boolean {
    const isValid = recordData['productType'] === 'PRODUCT_SET';
    !isValid && this.errorService.showErrorMessage('Тип продукта должен быть "Набор продуктов"!');
    return isValid;
  }
}
